import { Link } from "react-router-dom";
import { ArrowRight, Send } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function SplitCTA() {
  return (
    <section data-testid="split-cta-section" className="relative py-24">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-5 px-6 lg:grid-cols-2">
        <Reveal>
          <div className="group relative h-full overflow-hidden rounded-3xl border border-white/[0.08] bg-gradient-to-br from-[#0A1530] to-[#0A0F1D] p-10 sm:p-14">
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-blue-600/20 blur-3xl transition-opacity duration-700 group-hover:opacity-100" />
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-sky-400">For Employers</p>
            <h3 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Need great talent? Let's build your team.
            </h3>
            <Link
              to="/employers"
              data-testid="split-cta-hire-talent-btn"
              className="group/btn mt-8 inline-flex items-center gap-2 rounded-full bg-blue-600 px-7 py-3.5 text-sm font-semibold text-white shadow-[0_8px_30px_rgba(37,99,235,0.35)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-blue-500"
            >
              Hire Talent
              <ArrowRight size={16} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="group relative h-full overflow-hidden rounded-3xl border border-white/[0.08] bg-gradient-to-br from-[#141031] to-[#0A0F1D] p-10 sm:p-14">
            <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-indigo-500/20 blur-3xl transition-opacity duration-700 group-hover:opacity-100" />
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-indigo-400">For Candidates</p>
            <h3 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
              Ready for your next career move?
            </h3>
            <Link
              to="/candidates"
              data-testid="split-cta-submit-resume-btn"
              className="group/btn mt-8 inline-flex items-center gap-2 rounded-full border border-indigo-400/40 px-7 py-3.5 text-sm font-semibold text-indigo-200 transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-indigo-300/60 hover:bg-indigo-500/10"
            >
              Submit Your Resume
              <Send size={15} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
